<template>
  <!-- 弹框默认组件 -->
  <transition name="custom-dialog-fade" @after-leave="$emit('destroy')">
    <div class="mask popup" v-show="lsShow" @click="closeMask" :style="{ zIndex: zIndex }">
      <!-- 侧边弹窗 -->
      <div class="side-modal" @click.stop v-if="aside !== false">
        <div class="side-head">
          <slot name="header"></slot>
          <a class="trigger-close" mask-close v-if="hideClose === false" @click="tryClose">
            <i class="el-icon-close"></i>
          </a>
        </div>
        <div class="side-body">
          <el-scrollbar class="side-body-content">
            <slot></slot>
          </el-scrollbar>
        </div>
        <div class="side-footer" v-if="$slots.footer">
          <slot name="footer"></slot>
        </div>
      </div>
      <!-- 中间弹窗 -->
      <div class="fe-modal" @click.stop :size="size" v-else>
        <!-- 头部 -->
        <div class="modal-head">
          <div class="modal-header">
            <a class="trigger-close" mask-close v-if="hideClose === false" @click="tryClose">
              <i class="el-icon-close"></i>
            </a>
            <slot name="header"></slot>
          </div>
          <!-- 放在这里的筛选条件、按钮等等其他信息 -->
          <slot name="head"></slot>
        </div>
        <!-- 内容 -->
        <div class="modal-body">
          <el-scrollbar class="modal-body-content">
            <slot></slot>
          </el-scrollbar>
        </div>
        <div class="modal-footer" v-if="$slots.footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import { inject } from 'vue';

export default {
  name: 'yx-popup',
  props: {
    aside: {
      type: [String, Boolean],
      default: false,
    },
    size: {
      type: String,
      default: 'normal',
    },
    hideClose: {
      type: [String, Boolean],
      default: false,
    },
    zIndex: {
      type: Number,
      default: 1000,
    },
    beforeClose: {
      type: Function,
      default: null,
    },
    isAutoClose: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, context) {
    const lsShow = inject('lsShow');
    function tryClose() {
      if (props.beforeClose) {
        props.beforeClose(() => {
          context.emit('close');
        });
      } else {
        context.emit('close');
      }
    }

    return {
      lsShow,
      tryClose,
      closeMask() {
        if (props.aside !== false) {
          if (props.isAutoClose) {
            tryClose();
          }
        }
      },
    };
  },
};
</script>
<style lang="scss">
$animTime: 0.3s;
// 弹框基本样式
.mask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(5, 20, 51, 0.4);
  // background: rgba(0, 0, 0, 0.3);
  transition: opacity $animTime ease;
  opacity: 1;
  .fe-modal {
    width: 640px;
    background-color: var(--white);
    position: absolute;
    right: 0;
    left: 0;
    margin: 0 auto;
    // top: 15vh;
    top: 50% !important;
    transform: translateY(-50%) !important;
    border-radius: 8px;

    //遍历尺寸
    $sizes: (
      (
        type: 'w900',
        width: 900px,
        minHeight: 472px,
        contentWidth: 852px,
      ),
      (
        type: 'w1000',
        width: 1000px,
        minHeight: 572px,
        contentWidth: 952px,
      ),
      (
        type: 'extraLarge',
        width: 1200px,
        minHeight: 672px,
        contentWidth: 1152px,
      ),
      (
        type: 'large',
        width: 800px,
        minHeight: 372px,
        contentWidth: 752px,
      ),
      (
        type: 'middle',
        width: 640px,
        minHeight: 270px,
        contentWidth: 592px,
      ),
      (
        type: 'normal',
        width: 520px,
        minHeight: 148px,
        contentWidth: 472px,
      ),
      (
        type: 'small',
        width: 440px,
        minHeight: 108px,
        contentWidth: 392px,
      )
    );

    @for $i from 1 through length($sizes) {
      $item: nth($sizes, $i);

      &[size='#{map-get($item, type)}'] {
        width: map-get($item, width);

        .modal-body {
          min-height: map-get($item, minHeight);
        }
        .modal-body-content {
          width: map-get($item, contentWidth);
        }
      }
    }

    .modal-body {
      padding: 0 24px 0;
      overflow-y: auto;
      overflow-x: hidden;
      max-height: calc(70vh);
    }

    // 弹框顶部样式
    .modal-header {
      position: relative;
      // text-align: center;
      color: var(--g1);
      // font-size: 16px;
      font-size: 14px;
      line-height: 18px;
      // padding: 24px 0 0 24px;
      // padding: 16px 0 0 24px;
      padding: 0 20px;
      font-weight: 500;
      height: 52px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid var(--g6);
      cursor: grab;
      // 关闭按钮样式
      .trigger-close {
        position: absolute;
        // top: 28px;
        // right: 30px;
        top: 20px;
        right: 20px;
        font-size: 18px;
        cursor: pointer;
        color: var(--g3);
      }
    }
    // 底部样式
    .modal-footer {
      padding: 13px 20px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }

  .side-modal {
    position: absolute;
    right: 0;
    height: 100%;
    box-shadow: -2px 0 8px rgb(0 0 0 / 15%);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: var(--white);
    // border-radius: 16px 0px 0px 16px;
    border-radius: 8px 0px 0px 8px;
    .side-head {
      height: 64px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid var(--g6);
      padding: 0 20px;
      .trigger-close {
        position: absolute;
        top: 20px;
        right: 20px;
        font-size: 18px;
        cursor: pointer;
        color: var(--g3);
      }
    }
    .side-footer {
      height: 70px;
      padding: 0 20px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      border-top: 1px solid var(--g5);
    }
    .side-body {
      // flex: 1 0 auto;
      flex: 1;
      // height: calc(100% - 134px);
      padding: 0 0 0 24px;
      min-width:560px;
      overflow-y: auto;
      .side-body-content {
        height: 100%;
        overflow-x:hidden;
      }
    }
  }
}

.custom-dialog-fade-enter-active {
  opacity: 1;
  // .fe-modal {
  //   animation: custom-dialog-fade-in $animTime ease !important;
  // }
  .side-modal {
    animation: custom-dialog-fade-in-right $animTime ease !important;
  }
}

.custom-dialog-fade-leave-active {
  opacity: 0;
  // .fe-modal {
  //   animation: custom-dialog-fade-out $animTime ease !important;
  // }
  .side-modal {
    animation: custom-dialog-fade-in-right $animTime ease reverse !important;
  }
}

@keyframes custom-dialog-fade-in {
  0% {
    opacity: 0;
    transform-origin: 0% 50%;
    transform: scale(0.6);
  }
  100% {
    transform-origin: 0% 50%;
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes custom-dialog-fade-out {
  0% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translate3d(0, -20px, 0);
  }
}

@keyframes custom-dialog-fade-in-right {
  0% {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

.mask.popup .side-modal .el-form .el-select{
  width: 320px !important;
}
.mask.popup .side-modal .el-form .el-input{
  width: 320px !important;
}
.mask.popup .side-modal .el-form .el-textarea{
  width: 320px !important;
}
.mask.popup .side-modal .el-form .el-form-item__label{
  width: 125px !important;
}
</style>
